// Copyright (C) 2017, 2018 DecElite LLC - All Rights Reserved. May not be distributed or copied.
<template>
  <div class="help--toc">
    <h2 class="display-3 pt-4 pb-2">DartCannon Help</h2>
    <section> <!-- Getting Started -->
      <v-layout
        row
        justify-space-around
        wrap
        align-center>
        <v-flex xs12>
          <h2 class="headline grey--text text--darken-3">
            <v-icon>play_circle_filled</v-icon>
            Get Started
          </h2>
        </v-flex>
        <help-card
          to="/help/getting-started"
          icon="insert_chart"
          title="Your First Simulation">
          Introduction to DartCannon basics and using it for simulations
          of budgets.
        </help-card>
        <help-card
          to="/help/sample-use-cases/sales-projections"
          icon="monetization_on"
          title="Sales Projections">
          Bringing probability into projection sales and tracking
          targets.
        </help-card>
        <help-card
          to="/help/sample-use-cases/basic-project-planning"
          icon="timeline"
          title="Basic Project Planning">
          Using DartCannon for scheduling and forecasting completion
          times.
        </help-card>
      </v-layout>
    </section>

    <section> <!-- Help -->
      <v-layout
        row
        justify-space-around
        class="mt-3"
        wrap
        align-center>

        <v-flex xs12>
          <h2 class="headline grey--text text--darken-3">
            <v-icon>help</v-icon>
            Get Help
          </h2>
        </v-flex>

        <help-card
          to="/blog"
          icon="rss_feed"
          title="Blog">
          Find regular guides, product information and useful resources
          in the blog.
        </help-card>

        <!--
        <help-card
          to="/help/faq"
          icon="question_answer"
          title="FAQ">
          Find regular guides, product information and useful resources
          in the blog.
        </help-card>
        -->
        <help-card
          to="mailto:support@dartcannon.com"
          icon="mail"
          title="Contact">
          Get in touch if you're having any issues and we'll try to help.
        </help-card>

      </v-layout>
    </section>

    <section> <!-- Premium -->
      <v-layout
        row
        wrap
        class="mt-3"
        justify-space-around
        align-center>
        <v-flex
          class="mb-3"
          xs12>
          <h2 class="headline grey--text text--darken-3">
            <v-icon right>stars</v-icon>
            Premium Features
          </h2>
        </v-flex>
        <help-card
          to="/help/faq"
          icon="compare_arrows"
          title="Feature Comparison">
          Find regular guides, product information and useful resources
          in the blog.
        </help-card>
        <help-card
          to="/help/correlated-outcomes"
          icon="merge_type"
          title="Correlated Outcomes">
          Have individual outcomes relate to eachother.
        </help-card>
        <help-card
          to="/help/excel-import-export"
          icon="table_chart"
          title="Excel Import / Export">
          Export simulation results for further analysis or import extermally
          created plans for simulation.
        </help-card>
      </v-layout>
    </section>

    <section> <!-- Legal -->
      <v-layout
        row
        wrap
        class="mt-3"
        justify-space-around
        align-center>
        <v-flex
          class="mb-3"
          xs12>
          <h2 class="headline grey--text text--darken-3">
            <v-icon>gavel</v-icon>
            Legal
          </h2>
        </v-flex>
        <help-card
          to="/help/legal/terms-of-service"
          icon="vpn_key"
          title="Terms of Service">
          Understand the rules and how we'll enforce them.
        </help-card>
        <help-card
          to="/help/legal/privacy-policy"
          icon="remove_red_eye"
          title="Privacy Policy">
          We respect your privacy and want you to understand it.
        </help-card>
      </v-layout>
    </section>

  </div>
</template>
<script>
import * as VGrid from 'vuetify/es5/components/VGrid'
import * as VCard from 'vuetify/es5/components/VCard'
import VIcon from 'vuetify/es5/components/VIcon'
import HelpCard from './HelpCard.vue'

export default {
  components: {
    ...VGrid,
    ...VCard,
    VIcon,
    HelpCard,
  },
}
</script>
<style scoped>
.help--toc {
  max-width: 800px;
}
</style>
